import React, { useState } from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import CustomBill from "../../../../../components/Universal/CustomBill.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import UniversalTable from "../../../../../components/Universal/Tables/UniversalTable.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const Body = ({
  columns = [],
  historyData = [],
  isReceiptOpen,
  setIsReceiptOpen,
}) => {
  const [showHistory, setShowHistory] = useState(false);
  const [submittedValues, setSubmittedValues] = useState(null);
  const [showSuccess, setShowSuccess] = React.useState(false);

  // Helper component to render each field
  const Field = ({ label, value, multiline = false }) => (
    <div style={{ marginBottom: "1.2rem", paddingRight: "1rem" }}>
      <div
        style={{
          fontSize: "0.9rem",
          color: "#bbb",
          marginBottom: "0.25rem",
          fontWeight: 400,
        }}
      >
        {label}
      </div>
      <div
        style={{
          whiteSpace: multiline ? "pre-wrap" : "nowrap",
          fontWeight: 400,
          color: "#222",
          lineHeight: "1.5",
        }}
      >
        {value || "-"}
      </div>
    </div>
  );

  const data = {
    area: "School bathroom",
    totalAmount: 20453,
    paidAmount: 4500,
    provider: "Mahfizul khan team",
    contact: "9876543210",
    paymentMode: "Net banking",
    description:
      "Inspection is near about two hours within a campus.\nMainly school building. It touches a world class standard.",
    confirmedBy: "Javed Habib",
  };

  if (showHistory)
    return (
      <section className="ElectricBillHistorySection">
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && (
            <CustomBill data={submittedValues} vendorInfo={[]} />
          )}
        </ScrollableModal>
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="All payments history, cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"All payments history"} />
        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All food items and equipment payment history
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                </div>
                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowHistory(false)}
                  className="actionBtn"
                >
                  Go to cleaning and Sanitation
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>
          <div className="history-table">
            <UniversalTable
              columns={columns}
              data={historyData}
              maxBodyHeight="340px"
              footer={
                <div className="Amount-Indicators">
                  <div className="indicator-group">
                    <span className="indicator-box filled-orange">
                      Total count: <span className="text-white">236</span>
                    </span>

                    <span className="indicator-box outlined-orange">
                      Due amount:{" "}
                      <span className="text-orange">₹ 2,60,560</span>
                    </span>
                  </div>

                  <div className="indicator-group">
                    <span className="indicator-box outlined-blue">
                      Total amounts:{" "}
                      <span className="text-blue-light">₹ 2,60,560</span>
                    </span>

                    <span className="indicator-box filled-blue">
                      Paid amount:{" "}
                      <span className="text-white">₹ 2,60,560</span>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    );

  return (
    <section className="CleaningAndSanitationBody">
      <Helmet>
        <title>Dashboard</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Cleaning And Sanitation"} />
      <ScrollableModal
        isOpen={isReceiptOpen}
        onClose={() => setIsReceiptOpen(!isReceiptOpen)}
      >
        {isReceiptOpen && <CustomBill data={submittedValues} vendorInfo={[]} />}
      </ScrollableModal>
      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem" }}
        className="CleaningAndSanitation mt-2"
      >
        <div
          style={{ background: "white", padding: "2rem", borderRadius: "10px" }}
          className="CleaningAndSanitation__left"
        >
          <h2
            style={{
              color: "var(--grayColor)",
              fontWeight: "normal",
              borderBottom: "1px solid #ccc",
              paddingBottom: "0.5rem",
              marginBottom: "1rem",
            }}
          >
            Sheet for Cleaning & Sanitation department{" "}
          </h2>

          <Formik
            initialValues={{
              area: "",
              description: "",
              totalAmount: "",
              paidAmount: "",
              provider: "",
              contact: "",
              paymentMode: "",
              confirmedBy: "",
              gst: "",
            }}
            onSubmit={(values) => {
              console.log("Form submitted:", values);
              setSubmittedValues(values);
            }}
          >
            {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => (
              <form onSubmit={handleSubmit} className="accommodationForm">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "1rem",
                  }}
                  className="formGrid"
                >
                  <FormInput
                    label="Area/location name"
                    name="area"
                    placeholder="Enter a place for cleaning"
                    setFieldValue={(e) => setFieldValue("area", e.target.value)}
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="Description"
                    name="description"
                    placeholder="Type something here"
                    setFieldValue={(e) =>
                      setFieldValue("description", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="Total amount (INR)"
                    name="totalAmount"
                    type="number"
                    placeholder="Enter amount"
                    setFieldValue={(e) =>
                      setFieldValue("totalAmount", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="Paid amount (INR)"
                    name="paidAmount"
                    type="number"
                    placeholder="Enter paid amount"
                    setFieldValue={(e) =>
                      setFieldValue("paidAmount", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="Provider (if any)"
                    name="provider"
                    placeholder="Enter provider name"
                    setFieldValue={(e) =>
                      setFieldValue("provider", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="Contact (if any)"
                    name="contact"
                    placeholder="Enter provider contact number"
                    setFieldValue={(e) =>
                      setFieldValue("contact", e.target.value)
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <DropDownInput
                    name="paymentMode"
                    label="Payment mode"
                    placeholder="Choose payment mode"
                    suggestionList={["Cash", "UPI", "Bank Transfer", "Cheque"]}
                    setFieldValue={(val) => setFieldValue("paymentMode", val)}
                    setTouched={(name, isTouched) =>
                      setTouched({ [name]: isTouched })
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <DropDownInput
                    name="confirmedBy"
                    label="Confirmed by"
                    placeholder="Choose confirmed by"
                    suggestionList={["Manager", "Admin", "Finance Team"]}
                    setFieldValue={(val) => setFieldValue("confirmedBy", val)}
                    setTouched={(name, isTouched) =>
                      setTouched({ [name]: isTouched })
                    }
                    touched={touched}
                    errors={errors}
                  />

                  <FormInput
                    label="GST (if any)"
                    name="gst"
                    placeholder="Enter GST in %"
                    setFieldValue={(e) => setFieldValue("gst", e.target.value)}
                    touched={touched}
                    errors={errors}
                  />
                </div>

                <button
                  type="submit"
                  className="submitBtn actionBtn"
                  style={{ width: "100%", marginTop: "1.5rem" }}
                >
                  Add to the list and collect fund
                </button>
              </form>
            )}
          </Formik>
        </div>
        <div
          style={{
            background: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="CleaningAndSanitation__right"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: "1rem",
              borderBottom: "1px solid #ccc",
            }}
          >
            <h2 style={{ color: "var(--grayColor)", fontWeight: "normal" }}>
              Confirmation of payment
            </h2>
            <button
              onClick={() => setShowHistory(true)}
              style={{ height: "2.5rem" }}
              className="blueActionBtnLight"
            >
              All payments history{" "}
            </button>
          </div>
          {showSuccess ? (
            <div className="billSuccess">
              <h2
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "var(--deepGreen3)",
                  fontWeight: "500",
                }}
              >
                You have confirm payment successfully
              </h2>
              <p
                style={{
                  marginTop: "1rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Receipt ID: 23456789012
              </p>
              <h4
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                  marginBlock: "1rem",
                  fontWeight: "500",
                  fontSize: "1.2rem",
                  color: "var(--blueColor1)",
                  cursor: "pointer",
                }}
                onClick={() => setIsReceiptOpen(true)}
              >
                Receipt <BsBoxArrowRight />
              </h4>
              <button
                style={{ width: "100%" }}
                onClick={() => setShowSuccess(false)}
                className="actionBtn"
              >
                Okay
              </button>
            </div>
          ) : (
            true && (
              <div
                style={{
                  maxWidth: "800px",
                  margin: "auto",
                  padding: "2rem",
                  fontFamily: "sans-serif",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    rowGap: "1.5rem",
                    columnGap: "1rem",
                  }}
                >
                  <Field label="Area/location name" value={data.area} />
                  <Field
                    label="Total amount (INR)"
                    value={`₹ ${data.totalAmount.toLocaleString()}`}
                  />
                  <Field
                    label="Paid amount (INR)"
                    value={`₹ ${data.paidAmount.toLocaleString()}`}
                  />

                  <Field label="Provider" value={data.provider} />
                  <Field label="Contact" value={data.contact} />
                  <Field label="Payment mode" value={data.paymentMode} />

                  <div style={{ gridColumn: "span 2" }}>
                    <Field
                      label="Description"
                      value={data.description}
                      multiline
                    />
                  </div>
                  <Field label="confirmed by" value={data.confirmedBy} />
                </div>

                <button
                  style={{
                    marginTop: "2rem",
                    backgroundColor: "#6c9c5a",
                    color: "#fff",
                    border: "none",
                    width: "100%",
                    padding: "0.9rem",
                    fontSize: "1rem",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowSuccess(true)}
                >
                  Confirm payment
                </button>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
